import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { FileUploaderViaFirebaseStorage } from 'libs.firebase_react';
import { useLocalizeMessage } from 'libs.nucleus';
import { useImportState } from './contexts/import_state.context';
export const ImportMedableFormat = () => {
    const t = useLocalizeMessage();
    const { setFiles, setFilesLoading, setFilesLoaded } = useImportState();
    const handleFileChange = useCallback((files) => {
        setFiles(files);
    }, [setFiles]);
    const handleFilesLoading = useCallback(() => {
        setFilesLoading();
    }, [setFilesLoading]);
    const handleFilesLoaded = useCallback(() => {
        setFilesLoaded();
    }, [setFilesLoaded]);
    return (_jsx("div", { className: 'flex justify-center p-4 h-full', children: _jsx(FileUploaderViaFirebaseStorage, { storageBaseUrl: 'uploads/import_v2', label: t('Select translation files'), accept: '.json,.zip', multiple: true, onFileChange: handleFileChange, description: t('Upload individual or multiple files using .json or .zip formats.'), buttonLabel: t('Upload'), onLoaded: handleFilesLoaded, onSetFiles: handleFilesLoading }, '1') }));
};
